import { useQuery } from '@tanstack/react-query';

import { analyticsTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getInstagramFilters: analyticsTypes.GetInstagramFilters = (params) => {
  return axios.get(`/analytics/instagram-filters`, { params });
};

type QueryFnType = typeof getInstagramFilters;

type UseGetInstagramFilters = {
  dateFrom: number;
  dateTo: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetInstagramFilters = ({
  config = {},
  dateFrom,
  dateTo,
}: UseGetInstagramFilters) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['instagram-filters', dateFrom, dateTo],
    queryFn: () => getInstagramFilters({ dateFrom, dateTo }),
    enabled: !!dateFrom && !!dateTo,
  });
};
